export const DELAY_UNTIL_SHOW_LOADER = 750
